
import { useState, useEffect, useContext, createContext } from "react";

import { fetchSubjectsMetadata } from "../utilities/server-fetch";

// TODO: See RibonSubjectsContext.tsx LARGE COMMENT for future potential Refactor
//import { RibbonSubjectsContextProvider } from "./RibbonSubjectsContext";

import { SubjectSelector, SubjectTypeSelector, DropDownTypeSelector } from "@Beasted1010/pivotal-wisdom";

import { useSubjectsMetadata } from "./SubjectsMetadataContext";


export {
  RibbonContextProvider,
  useRibbon, useRibbonUpdate
};


const RibbonContext = createContext<any>( null ); // TODO: Properly fill out ??

const RibbonUpdateContext = createContext<any>( null ); // TODO: Properly fill out ??


function useRibbon() {
  return useContext( RibbonContext );
}

function useRibbonUpdate() {
  return useContext( RibbonUpdateContext );
}



type DropDown = ISubjectMetadata[] | IMoreMenuItem[];
type MenuItem = ISubjectMetadata | IMoreMenuItem;
// TODO: MOVE SOMEWHERE CAN ACCESS GLOBALLY - NOTE: Tried just cut to global.d.ts, but not work



// TODO: Rename to SubjectContext ??? - But it does only have subjectData out of necessity to get programData
// TODO: Lots going on here, consider splitting up in separate Contexts?
//     - But, Perhaps it's interleaved too much to be able to? At least consider what can do (un-interleave?)
//     - ... Currnetly focusSubject/focusMoreMenuItem could be moved elsewhere, but rely on a State Setter, so not so simply to Type that if were to move outside the Context Provider -- Could consider how at least re/move those functions
function RibbonContextProvider( {children}: ComponentProps ) {
  // Provider handles...

  // ... Creating State
  const [focusedDropDownName, setFocusedDropDownName] = useState<DropDownTypeSelector | undefined>( undefined );

  // SUBJECTS
  const [subjectsMetadata, setSubjectsMetadata] = useState<ISubjectMetadata[] | undefined>( undefined ); // All Subjects in Subject-Containing DropDown
  const [focusedSubject, setFocusedSubject] = useState<ISubjectMetadata | undefined>( undefined ); // The specific Subject Cursor is over in Subject-Containing DropDown

  // COACHING
  const [coachingData, setCoachingData] = useState<ICoaching | undefined>( undefined );
  const [coachingEngagements, setCoachingEngagements] = useState<IEngagement[] | undefined>( undefined );
  const [focusedCoachingEngagement, setFocusedCoachingEngagement] = useState<IEngagement | undefined>( undefined );

  // MORE
  const [moreDropDownEntries, setMoreMenuItems] = useState<IMoreMenuItem[] | undefined>( undefined );
  const [focusedMoreMenuItem, setFocusedMoreMenuItem] = useState<IMoreMenuItem | undefined>( undefined );


  const { specialtySubjectsMetadata, foundationSubjectsMetadata } = useSubjectsMetadata();


  // TODO:   Perhaps have a "DropDownContext" for Overlapping Code of DropDown Functionality? -- Need changes in Header.tsx prob though to get this generality
  useEffect( () => {

    const abortController = new AbortController();

    const getRibbonData = async () => {
      // Set Coaching DropDown Entries
      const newCoachingData: ICoaching = require(`../data/mock-coaching.json`);
      setCoachingData( newCoachingData );
      setCoachingEngagements( newCoachingData.engagements );

      // Set More DropDown Entries
      const moreEntries: IMoreMenuItem[] = require(`../data/mock-more-dropdown.json`);
      setMoreMenuItems( moreEntries );
    }

    getRibbonData();

    return () => {
      abortController.abort();
    }
  }, []);



  // ... Updating State
  function focusDropDown( name: DropDownTypeSelector ) {

    switch( name ) {
      case DropDownTypeSelector.FOUNDATION:
        setSubjectsMetadata( foundationSubjectsMetadata );
        setFocusedSubject( foundationSubjectsMetadata?.[0] );

        setFocusedDropDownName( DropDownTypeSelector.FOUNDATION );
        break;

      case DropDownTypeSelector.COURSES:
        setSubjectsMetadata( specialtySubjectsMetadata );
        setFocusedSubject( specialtySubjectsMetadata?.[0] );

        setFocusedDropDownName( DropDownTypeSelector.COURSES );
        break;

      case DropDownTypeSelector.COACHING:
        // ...

        setFocusedCoachingEngagement( coachingEngagements?.[0] );

        setFocusedDropDownName( DropDownTypeSelector.COACHING );
        break;

      case DropDownTypeSelector.MORE:
        // ...

        setFocusedMoreMenuItem( moreDropDownEntries?.[0] );

        setFocusedDropDownName( DropDownTypeSelector.MORE );
        break;

      default:
        // TODO: ERROR HANDLE
        console.error("INVALID DROP DOWN SELECTOR");
        break;
    }

  }

  function focusMenuItem( menuItemName: string ) {
    if( menuItemName == null ) return; // TODO: ERROR HANDLE

    switch( focusedDropDownName ) {
      case DropDownTypeSelector.FOUNDATION:
      case DropDownTypeSelector.COURSES:
        focusSubject( menuItemName );
        break;

      case DropDownTypeSelector.COACHING:
        focusCoachingEngagement( menuItemName );
        break;

      case DropDownTypeSelector.MORE:
        focusMoreMenuItem( menuItemName );
        break;

      default:
        // TODO: ERROR HANDLE
        console.error("INVALID DROP DOWN SELECTOR");
        break;
    }
  }

  function focusSubject( name: string ) {
    if( subjectsMetadata == null ) return; // TODO: ERROR HANDLE

    const subject = subjectsMetadata.find( subject => {
      return subject.name === name;
    });

    if( subject == null ) return; // TODO: ERROR HANDLE

    setFocusedSubject( subject );

    return subject;
  }

  function focusCoachingEngagement( name: string ) {
    if( coachingEngagements == null ) return; // TODO: ERROR HANDLE

    const engagement = coachingEngagements.find( engagement => {
      return engagement.name === name;
    });

    if( engagement == null ) return; // TODO: ERROR HANDLE

    setFocusedCoachingEngagement( engagement );

    return engagement;
  }

  function focusMoreMenuItem( name: string ) {
    if( moreDropDownEntries == null ) return; // TODO: ERROR HANDLE

    const entry = moreDropDownEntries.find( entry => {
      return entry.name === name;
    });

    if( entry == null ) return; // TODO: ERROR HANDLE

    setFocusedMoreMenuItem( entry );
  }


  // MOBILE
  function toggleNavMenu() {
    const navigationMenu = document.getElementById( "navigationMenu" );
    navigationMenu?.classList.toggle( "active" );
  }

  function expandMobileDropDown( name: string ) {

    if( name === focusedDropDownName ) {
      setFocusedDropDownName(undefined);
      return;
    }

    switch( name ) {
      case DropDownTypeSelector.FOUNDATION:
        setSubjectsMetadata( foundationSubjectsMetadata );
        setFocusedSubject( foundationSubjectsMetadata?.[0] );

        setFocusedDropDownName( DropDownTypeSelector.FOUNDATION );
        break;

      case DropDownTypeSelector.COURSES:
        setSubjectsMetadata( specialtySubjectsMetadata );
        setFocusedSubject( specialtySubjectsMetadata?.[0] );

        setFocusedDropDownName( DropDownTypeSelector.COURSES );
        break;

      case DropDownTypeSelector.COACHING:
        // ...

        setFocusedCoachingEngagement( coachingEngagements?.[0] );

        setFocusedDropDownName( DropDownTypeSelector.COACHING );
        break;

      case DropDownTypeSelector.MORE:
        // ...

        setFocusedMoreMenuItem( moreDropDownEntries?.[0] );

        setFocusedDropDownName( DropDownTypeSelector.MORE );
        break;

      default:
        // TODO: ERROR HANDLE
        console.error("INVALID DROP DOWN SELECTOR");
        break;
    }

  }


  // ... Persisting State down into Children
  return (
    <RibbonContext.Provider value={ {subjectsMetadata, focusedSubject, focusedDropDownName, coachingEngagements, moreDropDownEntries, focusedCoachingEngagement, focusedMoreMenuItem} } >
      <RibbonUpdateContext.Provider value={ {focusDropDown, focusMenuItem, focusSubject, focusCoachingEngagement, focusMoreMenuItem, toggleNavMenu, expandMobileDropDown} } >
        {children}
      </RibbonUpdateContext.Provider>
    </RibbonContext.Provider>
  )
}


// ================================= HELPERS =================================

// ...






/* */
